import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { SUB_COMPANY_ASSIGNED_AE_ACTION_TYPE } from '../actions';

const initialState = null;

const subCompanyAssignedAeReducer = (state = initialState, { type, payload }) =>
  produce(state, () => {
    switch (type) {
      case SUB_COMPANY_ASSIGNED_AE_ACTION_TYPE.GET_ASSIGNED_AE:
      case SUB_COMPANY_ASSIGNED_AE_ACTION_TYPE.SET_ASSIGNED_AE:
        return payload ?? initialState;

      case SUB_COMPANY_ASSIGNED_AE_ACTION_TYPE.RESET_STATE:
      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default subCompanyAssignedAeReducer;
